import { render, staticRenderFns } from "./backslider.vue?vue&type=template&id=9fcad1c8&"
import script from "./backslider.vue?vue&type=script&lang=js&"
export * from "./backslider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../emtsrc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports